import { useTranslate } from "hooks/useTranslate";
import BrandPlansList from "../BrandPlansList";

const BrandDeadline = () => {
  const translate = useTranslate();
  return <BrandPlansList type={translate("dashboard.PlanView.BrandDeadline")} />;
};

export default BrandDeadline;
